import React, { useEffect } from 'react'
import { downloadFile } from '../../../utils/downloadFile'
import './download-schema-button.css'

interface DownloadSchemaButtonProps {
  fileTitle: string
  fileObject?: any
}

export const DownloadSchemaButton: React.FC<DownloadSchemaButtonProps> = ({
  fileObject,
  fileTitle,
}) => {
  useEffect(() => {
    let downloadButtonElement: any
    let metaWrapElem

    downloadButtonElement = document.createElement('button')
    downloadButtonElement.textContent = 'Get Schema'
    downloadButtonElement.className = 'download-schema-button'
    downloadButtonElement.setAttribute('data-button-schema', 'getschema')
    downloadButtonElement.setAttribute('data-dxa', 'getschema')

    let targetElement = document.getElementById('downloadSchemaButton')

    if (document.getElementsByClassName('download-schema-button-container')) {
      metaWrapElem = document.createElement('div')
      metaWrapElem.className = 'download-schema-button-wrapper'
      metaWrapElem.appendChild(downloadButtonElement)
      // eslint-disable-next-line
      targetElement?.appendChild(metaWrapElem)
    }

    downloadButtonElement.addEventListener(
      'click',
      (ev: React.FormEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        downloadFile(fileObject, fileTitle)
      },
    )

    return () => {
      downloadButtonElement.removeEventListener(
        'click',
        (ev: React.FormEvent<HTMLButtonElement>) => {
          ev.preventDefault()
        },
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="download-schema-button-container">
      <div id="downloadSchemaButton" />
    </div>
  )
}
